<script lang="ts" setup>
const { getIndustryAttributes, getMetaAttributes } = useApiAttributes()
const { t } = useI18n()
const api = useApi()

const { data: response, execute, status } = useAsyncData(
  'doc:industries-find-similar',
  () => api.industries.fetchSimilar({ industries: ['saas'] }),
  { immediate: false },
)

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    path: '/industries/similar?industries[]=saas&size=10',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.industries'),
    example: '/industries/similar?industries[]=saas&industries[]=fintech',
    name: 'industries',
    required: true,
    type: 'array',
  },
  {
    description: t('attributes.page'),
    example: '/industries/similar?page=1',
    name: 'page',
    optional: true,
    type: 'number',
  },
  {
    description: t('attributes.size'),
    example: '/industries/similar?size=10',
    name: 'size',
    optional: true,
    type: 'number',
  },
]

const responseAttributes: ApiAttribute[] = [
  {
    attributes: getIndustryAttributes(),
    description: t('response.industries'),
    name: 'industries',
    type: 'array',
  },
  getMetaAttributes(),
]

async function onVisibilityChange(visibility: boolean) {
  if (visibility && !response.value) {
    await execute()
  }
}
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :loading="status === 'pending'"
    :query-attributes="queryAttributes"
    :response="response?.data"
    :response-attributes="responseAttributes"
    @visibility-change="onVisibilityChange"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "industries": "The industries to compare with (max: 10).",
      "page": "The page to fetch (default to 1).",
      "size": "The number of industries to be returned (between 1 and 100). Default to 25."
    },
    "response": {
      "industries": "The industries that match your conditions."
    }
  },
  "es": {
    "attributes": {
      "industries": "Las industrias para comparar (máx. 10).",
      "page": "La página a recuperar (por defecto 1).",
      "size": "El número de industrias a devolver (entre 1 y 100). Por defecto a 25."
    },
    "response": {
      "industries": "Las industrias que coinciden con tus criterios."
    }
  },
  "fr": {
    "attributes": {
      "industries": "Les industries à comparer (max: 10).",
      "page": "La page à récupérer (par défaut 1).",
      "size": "Le nombre d'industries à renvoyer (entre 1 et 100). Par défaut 25."
    },
    "response": {
      "industries": "Les industries qui correspondent à vos critères."
    }
  }
}
</i18n>
